import React from 'react';
import { Section } from './ui/Section';
export function ForWho() {
  const points = [{
    number: '01',
    title: 'El domingo es un peso',
    desc: 'Ansiedad porque no sabes qué enseñar el lunes.',
    icon: '😓'
  }, {
    number: '02',
    title: 'Planificas en tu tiempo libre',
    desc: 'La preparación te roba horas que deberían ser tuyas.',
    icon: '🌙'
  }, {
    number: '03',
    title: 'La música siempre falla',
    desc: 'Buscas canciones en el último momento sin criterio.',
    icon: '🎵'
  }, {
    number: '04',
    title: 'Alumnos que se van sin decir nada',
    desc: 'Pierdes alumnos sin entender por qué.',
    icon: '💸'
  }, {
    number: '05',
    title: 'No tienes sistema',
    desc: 'Sabes enseñar pero sin método documentado.',
    icon: '📚'
  }, {
    number: '06',
    title: 'No sabes cuánto cobrar',
    desc: 'Pones precio con miedo mirando a la competencia.',
    icon: '💶'
  }];
  return <Section data-id="element-112">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-113">
        👀 ¿Te Suena Familiar?
      </h2>
      <p className="text-center text-brand-textMuted mb-8 text-sm font-body italic" data-id="element-114">
        Si asientes con 2 o más, este sistema fue diseñado para ti.
      </p>

      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-4" data-id="element-115">
        {points.map((point, i) => <div key={i} className="bg-white border border-brand-border rounded-xl p-5 shadow-card hover:shadow-card-hover transition-all" data-id="element-116">
            <div className="flex items-start gap-3 mb-2" data-id="element-117">
              <span className="text-3xl" data-id="element-118">{point.icon}</span>
              <span className="text-brand-accent font-heading font-bold text-xl" data-id="element-119">
                {point.number}
              </span>
            </div>
            <h3 className="font-heading font-bold text-brand-subtitle mb-2 tracking-wide" data-id="element-120">
              {point.title}
            </h3>
            <p className="font-body text-brand-text text-sm leading-relaxed" data-id="element-121">
              {point.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}